
export default function Footer(props) {

    return <footer className="main-footer text-start alef" id="main-footer">
        <div className="footer-content">
            <div className="container">
                <div className="logo-holder">
                    <a href="https://www.mahuti.co.il/" >
                        <img src="https://www.mahuti.co.il/wp-content/themes/mahuti/images/img-logo-footer.svg" alt="מהותי, לעמוד הבית"/>
                    </a>
                </div>
                <div className="footer-content-wrapper">
                    <div className="footer-menu">
                        <div className="nav-menu">
                            <h4 className="almoni_tzar_light">
                                מהותי
                            </h4>
                            <ul className="nav-list">
                                <li id="menu-item-613" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-613"><a href="https://www.mahuti.co.il/purchase/" >הרשמה לפעילות</a></li>
                                <li id="menu-item-89" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-89"><a target="" rel="noopener" href="https://mahuti.secure.force.com/tickets#/" >רכישת כרטיסים</a></li>
                                <li id="menu-item-4721" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-4721"><a href="https://www.mahuti.co.il/merchav/" >מרחב מהותי הרשמה / כניסה</a></li>
                                <li id="menu-item-127" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-127"><a href="https://www.mahuti.co.il/about/" >אודות</a></li>
                                <li id="menu-item-1483" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1483"><a href="https://www.mahuti.co.il/contactus/" >צור קשר</a></li>
                                <li id="menu-item-126" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-126"><a href="https://www.mahuti.co.il/faq/" >שאלות ותשובות</a></li>
                            </ul>
                            <ul className="events-categories-menu">
                                <li id="menu-item-1341" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1341"><a href="https://www.mahuti.co.il/online/" >מהותי אונליין</a></li>
                                <li id="menu-item-148" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-148"><a href="https://www.mahuti.co.il/parents_and_kids-2/" >לכל המשפחה</a></li>
                                <li id="menu-item-147" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-147"><a href="https://www.mahuti.co.il/kids_and_teens_groups/" >קבוצות ילדים ונוער</a></li>
                                <li id="menu-item-145" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-145"><a href="https://www.mahuti.co.il/organizations_and_groups/" >ארגונים וקבוצות</a></li>
                                <li id="menu-item-5007" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-5007"><a href="https://www.mahuti.co.il/gathering/" >מפגש מהותי</a></li>
                                <li id="menu-item-722" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-722"><a href="https://www.mahuti.co.il/accessibiliyzone/" >נגישות</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="outer-links">
                        <h4 className="almoni_tzar_light">מהות החיים</h4>
                        <ul className="outer-links-list">
                            <li id="menu-item-98" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-98"><a target="" rel="noopener" href="https://www.eol.co.il/" >אתר מהות החיים</a></li>
                            <li id="menu-item-99" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-99"><a target="" rel="noopener" href="https://radio.eol.co.il/" >רדיו מהות החיים</a></li>
                        </ul>
                        <ul className="social-links">
                            <li id="menu-item-219" className="facebook menu-item menu-item-type-custom menu-item-object-custom menu-item-219">
                                <a target="" aria-label="פייסבוק" rel="noopener" href="https://www.facebook.com/%D7%9E%D7%94%D7%95%D7%AA%D7%99-112734705447140/?ref=br_tf" className="facebook" >FB</a>
                            </li>
                            <li id="menu-item-218" className="youtube menu-item menu-item-type-custom menu-item-object-custom menu-item-218">
                                <a target="" aria-label="יוטיוב" rel="noopener" href="https://www.youtube.com/channel/UCjygobr8hl-2mOqP_-GjdDg" className="youtube" >Youtube</a>
                            </li>


                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div className="copyright-holder">
            <div className="container">
                <span className="copyright">
                    כל הזכויות שמורות 2023 ©
                </span>
                <div className="rules-menu">
                    <a href="https://www.mahuti.co.il/accessibility/" >הצהרת נגישות</a>
                    <a href="https://www.mahuti.co.il/terms/" >תנאי שימוש</a>
                    <a href="https://www.mahuti.co.il/privacy/" >מדיניות פרטיות</a>
                    <a href="https://www.mahuti.co.il/sitemap/" >מפת אתר</a>
                    <a href="https://www.arisongroup.com/" >קבוצת אריסון</a>

                </div>
                <a href="" className="copyright-logo" >
                    <img src="https://www.mahuti.co.il/wp-content/themes/mahuti/images/img-logo-arison.svg" alt="Part of the Ted Arison Family Foundation" />
                </a>
            </div>
        </div>
    </footer>
}